import {Component, computed, input, InputSignal, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SidebarComponent} from '../sidebar';
import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-sidebar-toggle',
  imports: [CommonModule],
  templateUrl: './sidebar-toggle.component.html',
  styleUrl: './sidebar-toggle.component.scss',
  host: {
    '(click)': 'click()',
    '[class.hideButton]': 'hide()',
  },
})
export class SidebarToggleComponent {
  sidebar: InputSignal<SidebarComponent> = input.required<SidebarComponent>();

  icon: InputSignal<SvgSpriteIcon> = input.required<SvgSpriteIcon>();

  hide: Signal<boolean> = computed(() => this.sidebar()?.hideable() !== true);

  click() {
    this.sidebar().toggle();
  }
}
